<svg width="1000" height="150" [attr.viewBox]="'0 0 ' + (((splitters.length + boxes?.length) * space) + space) + ' 150'"
  fill="none" xmlns="http://www.w3.org/2000/svg">

  <g class="internal" *ngIf="internal && splitters.length"
    [attr.transform]="'translate(' + (((splitters.length - internal) * space) + space - 10 ) + ')'">
    <rect y="1" [attr.width]="internal * space" height="120" />
    <text [attr.x]="internal * space / 2" y="110" fill="white">INTERNAL</text>
  </g>

  <g class="cable">
    <rect x="80" y="47.5" [attr.width]="(splitters.length + boxes?.length) * space - 50" height="5" />
  </g>

  <g class="pon">
    <rect y="25" width="70" height="50" fill="#E2F7FE" stroke="#838EAA" />
    <rect x="70" y="35" width="15" height="30" fill="#2A9BB6" stroke="#156470" />
    <text class="text" x="8" y="54" i18n>PON Port</text>
  </g>

  <g class="splitters" [attr.transform]="'translate(' + ( (space * i) + space ) + ', 10)'"
    *ngFor="let splitter of splitters; let i = index">

    <polygon [attr.class]="'splitter s' + splitter" points="0,40 70,0 70,80" />
    <text x="44" y="45" class="splitter-text">
      1x{{splitter}}
    </text>
  </g>

  <g class="boxes" [attr.transform]="'translate('+ ( (space  * i) + space + (space * splitters.length) ) + ', 10)'"
    *ngFor="let box of boxes; let i = index">

    <rect [attr.class]="'box b' + box.replace('/', '-')" />
    <text x="40" y="45" class="box-text">
      {{box}}
    </text>
  </g>

</svg>